"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.validationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    content: mui_inputs_asset_1.templateAssetValidationSchema,
    price: mui_inputs_asset_1.templateAssetValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map